import { useState } from "react";
import axiosInstance from "../../axios";
import { useNavigate } from "react-router-dom";

interface LoginCredentials {
  email: string;
  password: string;
}

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const login = async (credentials: LoginCredentials) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post(
        "/auths/login/super-admin",
        credentials,
      );
      const { id } = response.data;
      localStorage.setItem("accessToken", id);
      setLoading(false);
      window.location.reload();
      navigate("/");
    } catch (error) {
      setLoading(false);
      console.error("Login error:", error);
    }
  };

  return { login, loading, error };
};

export default useLogin;
